import { render, staticRenderFns } from "./MultiInput.vue?vue&type=template&id=2976bbc1&"
import script from "./MultiInput.vue?vue&type=script&lang=ts&"
export * from "./MultiInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports